// ShowOfTheWeekUI.tsx
import React from "react";
import { connect } from "react-redux";
import { PerformanceEntity, StoreState } from "../../redux/store/types";
import { selectShowOfTheWeek } from "../../redux/selectors";

interface Props {
  featuredShow: PerformanceEntity | null;
}

const ShowOfTheWeekUI: React.FC<Props> = ({ featuredShow }) => {
  if (!featuredShow) return null;

  const { show_name, image } = featuredShow;
  return (
    <div className="flex w-100 h-100 show-of-the-week">
      <div className="w-50">
        {image && (
          <img
            src={image.replace(/^http:\/\//, "https://")}
            alt={show_name}
            className="w-100 h-100"
          />
        )}
      </div>
      <div className="w-50 h-100 flex flex-column items-center justify-center white center ph3">
        <h3 className="uppercase mb1 center">Show of the week</h3>
        <h2 className="f3 fw8 center">{show_name}</h2>
      </div>
    </div>
  );
};

export default connect((state: StoreState) => ({
  featuredShow: selectShowOfTheWeek(state),
}))(ShowOfTheWeekUI);